export default {
  state: {
    addresses: [
      {
        branch: 'Amman',
        country: 'Jordan',
        address: '3rd floor, 14 King Faisal Bin AbdelAziz St. - Umm Uthayna - Amman - Jordan',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate', 'reachPublishers']
      },
      {
        branch: 'Jarash',
        country: 'Jordan',
        address: '1st floor, 61 Qassim Abu Lubbad St. - Souf - Jerash - Jordan',
        companies: ['reachPublishers']
      },
      {
        branch: 'Amman',
        country: 'Jordan',
        address: '806-8th floor,314 Zahran Street Al Husseini Group Commercial Building-between 7th-8th Circle – Amman – Jordan',
        companies: ['reachStudyAbroad']
      },
      {
        branch: 'Riyadh',
        country: 'KSA',
        address: 'Office No.23 - Al Takhasosi St. - Al-Thumamah Road - Opposite to Al Tamimi Market - Above Al Jazera bank - Riyadh- KSA',
        companies: ['reachStudyAbroad']
      },
      {
        branch: 'Riyadh',
        country: 'KSA',
        address: 'Office No.23 - Al Takhasosi St. - Al-Thumamah Road - Opposite to Al Tamimi Market - Above Al Jazera bank - Riyadh- KSA',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Jeddah',
        country: 'KSA',
        address: 'Office No. 504 - 5th Floor - Arkan Bldg - Nahdat Al-Tareekh St. - Alrawda district - Jeddah - KSA',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Khobar',
        country: 'KSA',
        address: 'Office No. 905 - 9th Floor - Awj Tower - Prince Turki road - Khobar - KSA',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Sheraton',
        country: 'Egypt',
        address: 'Office No.16 - 4th floor - 87 Almosheer Ahmed Ismail St. - Sheraton District – Heliopolis - Cairo - Egypt',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: '5th Settlement',
        country: 'Egypt',
        address: 'Sodic Eastown, New Cairo Gate #9, Next to the AUC Building No.7 1st floor, office No.2, 5th Settlement, Egypt',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: '6 October',
        country: 'Egypt',
        address: 'Office No.102 - Capital Business Park B2 - Plot No.15 - 16 - Sheikh Zayed City - Giza - Egypt',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Maadi',
        country: 'Egypt',
        address: 'Rayhanah Plaza - Morshedy Group, Zahra Al Maadi, Tower A, Floor No. 4, Office No 12-4',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Alexandria',
        country: 'Egypt',
        address: 'Office No.20/No.22 - Ground Floor - Four Seasons Hotel San Stefano- El-Gaish Road- Alexandria- Egypt',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Baghdad',
        country: 'Iraq',
        address: 'In front of the Greek embassy St., Nadi Al Said St., Al Amirat, Al Mansour, Baghdad, Iraq',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Erbil',
        country: 'Iraq',
        address: 'Empire Business Towers, Building T2, 15th Floor, Office No. 2, Empire World, Erbil, Iraq',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Basra',
        country: 'Iraq',
        address: 'Basra, Manawi Basha, AlMedaan Street, beside Manawi center Building',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Larnaca',
        country: 'Cyprus',
        address: 'Vasileos Evagorou 14, 6023, Larnaca, Cyprus',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Kuwait',
        country: 'Kuwait',
        address: 'Office No. 43, 15th Floor, Salwa Tower, Abdul Aziz Al Saqr Street, Kuwait City – Al Mergab, Block 1.',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Doha',
        country: 'Qatar',
        address: 'Office No.3 - 22nd Floor - Amwal Tower - Ambassadors St. - West Bay - Doha - Qatar',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Dubai',
        country: 'UAE',
        address: 'Office No. 505 - 5th Floor - U-Bora Tower - Towers St. - Business Bay - Dubai - UAE',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Istanbul',
        country: 'Turkey',
        address: 'KAYABAŞI mah. Kayaşehir Bul. Nidakule No: 45 İç Kapı, kat 25 No: 180, Başakşehir/Istanbul',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Damascus',
        country: 'Syria',
        address: 'Abu Rummaneh Building (1), Opposite Guest Palace (Qasr al-Diyafa), Al-Jalaa Street, Damascus, Syria',
        companies: ['reachWorld', 'reachRRE&RI', 'reachRealEstate']
      },
      {
        branch: 'Amman',
        country: 'Jordan',
        address: '3rd floor, 14 King Faisal Bin AbdelAziz St. - Umm Uthayna - Amman - Jordan',
        companies: ['kaleela']
      }
    ],
    selected: null,
    selectedObj: null,
    customCountryOrder: [
      'Jordan',
      'KSA',
      'Egypt',
      'Iraq',
      'Kuwait',
      'Qatar',
      'UAE',
      'Syria',
      'Turkey',
      'Libya',
      'Cyprus'
    ],
    selectedBranchAddresses: []
  },
  getters: {
    getAddress: state => state
  },
  mutations: {
    SET_SELECTED_BRANCH (state, selected) {
      state.selectedBranchAddresses = []
      state.addresses.forEach((item) => {
        if (item.companies.includes(selected)) {
          state.selectedBranchAddresses.push(item)
        }
      })

      state.selectedBranchAddresses.sort((a, b) => {
        const countryOrderA = state.customCountryOrder.indexOf(a.country)
        const countryOrderB = state.customCountryOrder.indexOf(b.country)

        if (countryOrderA < countryOrderB) {
          return -1
        } else if (countryOrderA > countryOrderB) {
          return 1
        } else {
          if (a.branch < b.branch) {
            return -1
          } else if (a.branch > b.branch) {
            return 1
          }
          return 0
        }
      })
    },
    SET_ADDRESS_SELECTED (state, branch) {
      state.selectedBranchAddresses.forEach((item) => {
        if (item.branch === branch) {
          state.selected = item.branch
          state.selectedObj = item
        }
      })
    }
  },
  actions: {
    async updateAddress ({ commit, dispatch, rootState }, payload) {
      commit('SET_SELECTED_BRANCH', payload)
    },
    async updateSelectedAddress ({ commit, dispatch, rootState }, payload) {
      commit('SET_ADDRESS_SELECTED', payload)
    }
  }
}
